import parseuri from 'parseuri';

// Call the session endpoint to notify the backend that the user is still active.
var extendSession = function extendSession(host) {
  // TODO: Experiment with using Axios to facilitate the API calls in this project.
  var request = new XMLHttpRequest();
  request.onerror = function () {
    throw new Error('Could not contact the session service');
  };
  request.open('GET', "".concat(host, "/api/session"));
  request.setRequestHeader('Content-Type', 'application/json');
  request.send();
};

/*
 * This function notifies the backend when the user is playing a video (or has played one
 * in the last 5 minutes) so that they don't get logged out for being inactive in the middle
 * of their video. This is needed because the user normally gets logged out after being
 * inactive for 30 minutes, but many of our resource library videos are longer than 30 minutes.
 */
var videoActivityTracker = function videoActivityTracker(host) {
  // This tells us the user's previous place in each video on the screen so we can check if
  // it's different every 5 minutes.
  var previousVideoState = [];

  // Check if the user's place in any of the videos on the screen is different from last time.
  var videoPositionChanged = function videoPositionChanged(videos) {
    if (videos.length && videos.length === previousVideoState.length) {
      return videos.some(function (video, i) {
        return video.currentTime !== previousVideoState[i];
      });
    }
    return false;
  };

  // Extend the session if any videos were played in the last 5 minutes.
  return setInterval(function () {
    // Get all videos on the screen.
    var videos = Array.from(document.querySelectorAll('video'));

    // Extend session if any were played in the last 5 minutes.
    if (videoPositionChanged(videos)) extendSession(host);

    // Save positions of videos to compare again in 5 minutes.
    previousVideoState = videos.map(function (video) {
      return video.currentTime;
    });
  }, 300000);
};

var intervals = [];
function sessionTracker(isLoggedIn) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // TODO: extend options for consumer (use Object.assign to overwrite defaults with passed in options)
  var openNew = XMLHttpRequest.prototype.open;
  // Determines if enough time has passed to trigger call again
  var intervalCleared = true;
  var externalIntervalCleared = false;
  var currentHostname = window.location.hostname;
  // A host to use if localhost is not preferred (defined when calling this module)
  var fallbackHost = typeof opts.fallbackHost !== 'undefined' ? opts.fallbackHost : window.location.origin;
  var isLocalHost = currentHostname === 'localhost';
  // Host to use for call to /status
  var statusHost = isLocalHost ? fallbackHost : window.location.origin;
  // Final endpoint to use in network call to /status
  var statusLocation = "".concat(statusHost, "/api/status");
  // Logout path
  var logoutLocation = "".concat(window.location.origin, "/auth/logout?redirect=/identity/login?errorCode=Expired");
  // Action to take when session ends
  var endSession = function endSession() {
    window.location = logoutLocation;
  };
  // List of endpoints to NOT trigger this functionality against
  // Allow blacklist to be overwrite by host emd-js so it can be adjust when needed, else use default list
  var blacklist = typeof opts.blacklist !== 'undefined' ? opts.blacklist : ['/api/status', '/api/session', '/api/params', '/favicon.ico', '/api/identity/Email/Status', '/event-heartbeat', '/cm-beat', '/status', '/authenticate', '/identity/connect/token', '/session', '/v2/track', '//v2/track'];
  // whitelist of routes the will extend the session automatically if the user is on them
  // used in ashcare-ui-react for the live sessions component
  var whitelist = typeof opts.whitelist !== 'undefined' ? opts.whitelist : [];
  var activeTimer;
  var inactiveTimer;

  // Only gets called when you hit the backend
  var runStatusCheck = function runStatusCheck(status, url) {
    var requestUrl = parseuri(url);
    var requestEndpoint = requestUrl.path;
    // Only trigger call if the request uses one of these endpoints
    var acceptedVerbs = ['GET', 'PUT', 'POST', 'DELETE'];

    // If request meets all requirements, trigger request to /status
    if (!blacklist.includes(requestEndpoint) && acceptedVerbs.includes(status) && isLoggedIn && !isLocalHost) {
      // If any endpoint returns 401, kick the member out
      if (status === 401) {
        endSession();
      }
      // Only call the status endpoint if intervalCleared is true.
      else if (intervalCleared) {
        // Set intervalCleared to false to prevent multiple calls to the status endpoint within the interval.
        intervalCleared = false;
        statusNetworkCall(statusLocation);
      }
    }
  };
  // Only gets called when you hit the backend
  var runExternalApiStatusCheck = function runExternalApiStatusCheck(url) {
    var requestUrl = parseuri(url);
    var requestEndpointHost = requestUrl.host;

    // If request meets all requirements, extend the user session
    if (
    //check that the request host is in the white list
    whitelist.find(function (url) {
      return requestEndpointHost.includes(url);
    }) && isLoggedIn && !isLocalHost) {
      // Only call the status endpoint if externalIntervalCleared is true.
      if (externalIntervalCleared) {
        externalIntervalCleared = false;
        extendSession(statusHost);
      }
    }
  };

  // Create XMLHttpRequest to hit /status endpoint
  // Only gets called when you hit the backend
  var statusNetworkCall = function statusNetworkCall(url) {
    var request = new XMLHttpRequest();
    request.onload = function (event) {
      // Handle response from /status
      statusListener(event);

      // Re-sync active/inactive timers with data from /status
      syncTimers(JSON.parse(request.response));
    };
    request.onerror = function () {
      throw new Error('Could not contact the status service');
    };
    request.open('GET', url);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send();
  };
  var sessionNetworkCall = function sessionNetworkCall(url, done) {
    var request = new XMLHttpRequest();
    request.onload = function () {
      // If session is expired, returning 401, kick member out
      if (request.status === 401) {
        endSession();
      } else {
        done(JSON.parse(request.response));
      }
    };
    request.onerror = function () {
      throw new Error('Could not contact the session service');
    };
    request.open('GET', url);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send();
  };

  // Handle call to /status endpoint
  var statusListener = function statusListener(event) {
    var status = event.target.status;

    // Set timer to mark intervalCleared variable as true
    debounceTimer();

    // If call returns 401, refresh page to kick out user
    if (status === 401) {
      endSession();
    }
  };

  // Set the intervalCleared variable to true after 5 seconds
  var debounceTimer = function debounceTimer() {
    window.setTimeout(function () {
      intervalCleared = true;
    }, 5000);
  };
  var syncTimers = function syncTimers(data) {
    var newActive = data.activeTimeToLive;
    var newInactive = data.inactiveTimeToLive;

    // Clear timers
    window.clearTimeout(activeTimer);
    window.clearTimeout(inactiveTimer);

    // Then re-set with timer data from the backend
    activeTimer = window.setTimeout(endSession, newActive);
    inactiveTimer = window.setTimeout(endSession, newInactive);
  };

  // Extend XMLHttpRequest open prototype to run function on all network requests
  XMLHttpRequest.prototype.open = function (status, url) {
    this.addEventListener('load', function () {
      runStatusCheck(status, url);
      runExternalApiStatusCheck(url);
    }, false);
    openNew.apply(this, arguments);
  };

  // Only track session if logged in and not on localhost. We don't need to track it when
  // developing on localhost since we're not even hitting the backend anyways.
  if (isLoggedIn && !isLocalHost) {
    intervals.push(videoActivityTracker(statusHost));

    // Initialize timeout timers
    sessionNetworkCall(statusLocation, function (data) {
      syncTimers(data);
    });

    // Re-sync after 15 minutes to ensure client timers are the same as backend timers
    intervals.push(setInterval(function () {
      sessionNetworkCall(statusLocation, function (data) {
        syncTimers(data);
      });
    }, 900000), setInterval(function () {
      //only allow external api to extend session every 5 min
      externalIntervalCleared = true;
    }, 300000));
  }
}

// Call this to clear the intervals upon unmounting.
var cleanup = function cleanup() {
  intervals.forEach(function (interval) {
    clearInterval(interval);
  });
};

export { cleanup, sessionTracker };
